import { Card } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { ChevronRight } from 'lucide-react';

/**
 * Shared event-detail body: SITUATION, pipeline, destination.
 * `flush` — no Card chrome (Inbox split); full-page keeps Card.
 */
function GenericEventBody({ event, flush = false }) {
  const { t } = useTranslation('work-queues-app');

  const content = (
    <>
      <div>
        <p className="text-xs font-semibold uppercase tracking-wide text-content-faint">
          {t('detail.situation')}
        </p>
        <p className="mt-2 text-sm leading-relaxed text-content-secondary">
          {event.situation ?? event.description}
        </p>
      </div>

      {event.pipeline?.length > 0 && (
        <div className="mt-4 flex flex-wrap items-center gap-1.5 text-xs text-content-muted">
          {event.pipeline.map((step, index) => (
            <span key={step} className="inline-flex items-center gap-1.5">
              <span className="rounded-md bg-surface-muted px-2 py-1">{step}</span>
              {index < event.pipeline.length - 1 && (
                <ChevronRight size={14} className="text-content-faint" />
              )}
            </span>
          ))}
        </div>
      )}

      {event.destination && (
        <div className="mt-4">
          <p className="text-xs font-semibold uppercase tracking-wide text-content-faint">
            {t('detail.destination')}
          </p>
          <p className="mt-1 text-sm font-medium text-content">{event.destination}</p>
        </div>
      )}
    </>
  );

  if (flush) {
    return <div className="flex flex-col">{content}</div>;
  }

  return (
    <Card>
      <Card.Body>{content}</Card.Body>
    </Card>
  );
}

export default GenericEventBody;
